import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const materialDeliveryDocumentStatus = enumerated({
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
})

export const materialDeliveryDocumentObject = z.object({
  id: z.string().uuid(),
  materialDeliveryId: z.string().uuid(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: materialDeliveryDocumentStatus,
})

export type MaterialDeliveryDocumentType = z.infer<typeof materialDeliveryDocumentObject>

export const propertyMap = {
  id: sql`material_delivery_document.id`,
  materialDeliveryId: sql`material_delivery_document.material_delivery_id`,
  gcsIdentifier: sql`material_delivery_document.gcs_identifier`,
  url: sql`material_delivery_document.url`,
  fileName: sql`material_delivery_document.file_name`,
  mimeType: sql`material_delivery_document.mime_type`,
  createdAt: sql`material_delivery_document.created_at`,
  updatedAt: sql`material_delivery_document.updated_at`,
  deletedAt: sql`material_delivery_document.deleted_at`,
  status: sql`material_delivery_document.status`,
}
